function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_67",
  "data-name": "Caminho 67",
  d: "M415-154.872v1.128h1.128v7.571H415v2.255h4.51v-2.094a8.071,8.071,0,0,1,.129-2.094,22,22,0,0,1,1.8,2.094l1.691,2.094H426.6v-2.255h-.693c-.677,0-.741-.048-1.8-1.3l-1.1-1.289,1.1-1.111c.966-.966,1.16-1.1,1.563-1.015l.451.081v-1.965H420.8v1.772h.725c.4,0,.725.048.725.129a20.094,20.094,0,0,1-2.626,2.609,32.781,32.781,0,0,1-.113-3.866V-156H415Z",
  transform: "translate(-356.865 156.11)",
  fill: "#1a91fa"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_70",
  "data-name": "Caminho 70",
  d: "M301.726-137.426a4.547,4.547,0,0,0-4.027,4.591,4.5,4.5,0,0,0,4.14,4.591c3.012.483,5.654-1.385,5.863-4.156a4.256,4.256,0,0,0-.822-3.125A5.314,5.314,0,0,0,301.726-137.426Zm2.03,2.738a3.4,3.4,0,0,1-.1,3.818,1.477,1.477,0,0,1-1.756.145,2.992,2.992,0,0,1-.773-2.11,2.992,2.992,0,0,1,.773-2.11,1.708,1.708,0,0,1,.87-.225A1.082,1.082,0,0,1,303.756-134.688Z",
  transform: "translate(-258.459 140.597)",
  fill: "#1a91fa"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_71",
  "data-name": "Caminho 71",
  d: "M370.524-136.758a3.553,3.553,0,0,0-1.595,1.434l-.419.628v-2.142H364v2.255h1.289v4.349H364v2.255h6.121v-2.255h-1.5l.1-.966a2.549,2.549,0,0,1,2.513-2.69l.822-.1V-137h-.515A3.219,3.219,0,0,0,370.524-136.758Z",
  transform: "translate(-314.08 140.171)",
  fill: "#1a91fa"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_72",
  "data-name": "Caminho 72",
  d: "M193-134.956v1.128h1.047l1.24,3.27,1.224,3.254,1.595.048,1.579.032.548-1.562c.306-.87.725-2.126.918-2.787.242-.757.37-1.047.37-.757a22.87,22.87,0,0,0,.773,2.771l.757,2.336h3.238l1.273-3.3c1.24-3.238,1.273-3.3,1.724-3.3h.467v-2.255h-4.188v2.255h.483a1.884,1.884,0,0,1,.483.032c0,.032-.29.918-.644,1.981-.4,1.273-.628,1.772-.644,1.45a22.552,22.552,0,0,0-.789-3.061L203.663-136l-1.514-.048-1.514-.048-1.031,3.077c-1.015,3-1.047,3.06-1.144,2.384a17.469,17.469,0,0,0-.451-1.836c-.177-.628-.338-1.192-.338-1.256,0-.048.226-.1.483-.1h.483v-2.255H193Z",
  transform: "translate(-170.625 139.416)",
  fill: "#1a91fa"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_3308",
  "data-name": "Grupo 3308",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_84",
  "data-name": "Caminho 84",
  d: "M65-196.372v1.228h1.249v7.618l-.572-.042L65.1-187.6v2.446h4.683V-186l.4.312a3.11,3.11,0,0,0,2.154.666,3.789,3.789,0,0,0,3.268-1.676,4.593,4.593,0,0,0,.885-3.091,4.734,4.734,0,0,0-.8-2.956,3.527,3.527,0,0,0-3-1.759,3.307,3.307,0,0,0-2.373.614,3.144,3.144,0,0,1-.479.3,18.719,18.719,0,0,1-.052-2.009v-2l-2.394-.01H65Zm7.035,4.548a1.836,1.836,0,0,1,.572.708,3.934,3.934,0,0,1,.01,2.82,1.394,1.394,0,0,1-2.113.572,2.293,2.293,0,0,1-.718-2.009,2.454,2.454,0,0,1,.239-1.353A1.409,1.409,0,0,1,72.035-191.824Z",
  transform: "translate(-65 197.6)",
  fill: "#1a91fa"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_86",
  "data-name": "Caminho 86",
  d: "M186.235-167.688a5.32,5.32,0,0,0-2.924,2.165,5.312,5.312,0,0,0,.052,5.1,5.011,5.011,0,0,0,4.506,2.154,5.462,5.462,0,0,0,3.767-1.29c.593-.531,1.062-1.29.843-1.363-.073-.021-.708-.187-1.4-.364l-1.27-.312-.458.458a1.554,1.554,0,0,1-.9.531,1.772,1.772,0,0,1-2.206-1.457l-.042-.312,3.309-.031,3.3-.021v-.676a4.369,4.369,0,0,0-1.29-3.341,5.029,5.029,0,0,0-2.2-1.249A9.066,9.066,0,0,0,186.235-167.688Zm2.55,2.362a1.629,1.629,0,0,1,.593,1.124c0,.2-.062.208-1.6.208h-1.6l.1-.427A1.64,1.64,0,0,1,188.785-165.326Z",
  transform: "translate(-170.437 170.925)",
  fill: "#1a91fa"
}));

function SvgBeworkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Imagem-11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.732,
    height: 12.655,
    viewBox: "0 0 69.732 12.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeworkLogo);
export default __webpack_public_path__ + "static/media/bework-logo.2f274b90.svg";
export { ForwardRef as ReactComponent };